<template>
  <div id="ContactInfomationComponent" class="contact-layout">
    <v-card outlined
      ><v-card-title> {{ $t("vendor.headerStep4") }}</v-card-title
      ><v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row align="center" class="pa-4">
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyContactPoint"
                :rules="[(v) => !!v || 'Contact Name is required']"
                :label="$t('vendor.companyContactPoint')"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyContactPointTel"
                :label="$t('vendor.tel')"
                required
                :rules="[(v) => !!v || 'Telephone is required']"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyToEmail"
                :label="$t('vendor.email')"
                required
                :rules="[
                  (v) => !!v || 'E-mail is required',
                  (v) => emailRules.test(v) || 'E-mail must be valid',
                ]"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyCcEmail"
                :label="$t('vendor.companyCcEmail')"
                required
                :rules="[
                  (v) => !!v || 'CC E-mail is required',
                  (v) => !v || v.replace(/[\s,:;]+/g, ' ').trim().split(' ').every((w) => emailRules.test(w))
                  || 'CC E-mail must be valid, Please separate each e-mail address with a space, comma (,) or semicolon (;)',
                ]"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-select
                outlined
                dense
                v-model="registerModel.gulfContactPointId"
                :items="gulfContactPoint"
                :label="$t('vendor.gulfContactPoint')"
                item-text="fullName"
                item-value="id"
              ></v-select
            ></v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                rows="2"
                :label="$t('vendor.others')"
                v-model="registerModel.others"
              ></v-textarea
            ></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ContactInfomationComponent",
  props: {
    propsGulfContactPoint: {
      type: Array,
      default: () => [],
    },
    propRegisterModel: {
      type: [Object, Array],
      default: () => {},
    },
    formType: {
      type: String,
      default: "Register",
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
  },
  data: () => ({
    emailRules: /^([0-9A-Za-z]+([-._+'][0-9A-Za-z]+)*)@([0-9A-Za-z]+([-.][0-9A-Za-z]+)*\.[a-zA-Z]{2,})$/,
    gulfContactPoint: [],
    registerModel: {},
    valid: true,
  }),
  watch: {
    propsGulfContactPoint(value) {
      if (value) {
        this.gulfContactPoint = value;
      }
    },
    propRegisterModel(value) {
      if (this.formType === "Edit") {
        this.registerModel = value;
      }
    },
    propCheckStep(value) {
      if (value === 4) {
        this.validate();
      }
      if (value === 3) {
        if (this.formType === "Edit") {
          this.registerModel = this.propRegisterModel;
        }
      }
    },
  },
  methods: {
    async validate() {
      await this.$refs.form.validate();
      if (this.valid === true) {
        this.$emit("EmitDataContact", this.registerModel);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.col {
  padding: 0 0.5rem;
}
</style>
